/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { RECURRING_PROFILE_STATUS } from "../../constants/constants";

// Translation keys for the dates a profile can show.
const DATE_LABEL = {
  NEXT: "recurring_profile_next_date",
  START: "recurring_profile_start_date",
  LAST: "recurring_profile_last_date",
  CANCELLATION: "recurring_profile_cancellation_date",
};

// The dates a profile can show, in display order, each with the key it is labelled by.
// Dates the profile does not have are left out. The next charge is shown only on an
// active profile (the backend leaves it populated after cancellation), and the
// cancellation date only on a cancelled one.
export const getRecurringProfileDates = (profile) => {
  if (!profile) return [];

  const isActive = profile.status === RECURRING_PROFILE_STATUS.ACTIVE;
  const isCancelled = profile.status === RECURRING_PROFILE_STATUS.CANCELLED;

  return [
    { labelKey: DATE_LABEL.NEXT, value: isActive ? profile.next_payment_datetime : null },
    { labelKey: DATE_LABEL.START, value: profile.start_datetime },
    { labelKey: DATE_LABEL.LAST, value: profile.last_payment_datetime },
    { labelKey: DATE_LABEL.CANCELLATION, value: isCancelled ? profile.cancellation_datetime : null },
  ].filter(({ value }) => !!value);
};

// The date that leads a compact view: the upcoming charge, or the cancellation.
export const getRecurringProfileLeadDateKey = (profile) =>
  profile?.status === RECURRING_PROFILE_STATUS.ACTIVE ? DATE_LABEL.NEXT : DATE_LABEL.CANCELLATION;
